import Link from 'modules/common/Link';
import PropTypes from 'prop-types';
import React from 'react';

const StepWrapper = ({
  courseSlug,
  handleMouseEnter,
  handleMouseLeave,
  stageSlug,
  step,
  isDegree,
  trackSlug,
  accessible,
  children,
}) => {
  const url = step.isLocked && !accessible ? `/subscription` :
    `/${isDegree ? 'degrees/' : ''}${trackSlug}/${courseSlug}/${stageSlug}/${step.slug}`

  return (
    <div className="flex">
      <Link
        to={url}
        state = {{ fromLink: window.location.pathname }}
        className="db pv2 ph3 cf link mb0-ns mb2"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </Link>
    </div>
  );
};

StepWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  courseSlug: PropTypes.string.isRequired,
  isDegree: PropTypes.bool,
  handleMouseEnter: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired,
  stageSlug: PropTypes.string.isRequired,
  step: PropTypes.object.isRequired,
  trackSlug: PropTypes.string,
};

export default StepWrapper;
